export default function isReactSnap() {
  return (
    typeof navigator !== "undefined" && navigator.userAgent === "ReactSnap"
  );
}
